import React, { Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import auth from '../common/utility/auth';

export default function PrivateRoute(props) {
    return (
        <Fragment>
            {auth.isAuthenticated() ? props.children : <Redirect to='/auth' />}
        </Fragment>
    );
}